export const VERIFIED = 'Verified';
export const UNVERIFIED = 'Unverified';
export const WARNING = 'Warning';
export const ERROR = 'Error';

export const VER = 'VER';
export const UNV = 'UNV';
export const WRN = 'WRN';
export const ERR = 'ERR';

export const AddressVerificationStatusMap = {
  [VERIFIED]: VER,
  [UNVERIFIED]: UNV,
  [WARNING]: WRN,
  [ERROR]: ERR,
};

export const ReverseEnumMap = {
  [UNV]: UNVERIFIED,
  [VER]: VERIFIED,
  [WRN]: WARNING,
  [ERR]: ERROR,
};

export const getFromPlainTextStatus = (status) => AddressVerificationStatusMap[status];
export const getFromAbbreviation = (abbreviation) => ReverseEnumMap[abbreviation.toUpperCase()];

export const AddressVerificationStatusValues = Object.values(AddressVerificationStatusMap);
